import {TRACKING_DEVICE_TOKEN_KEY} from "../../const/LocalStorage";
import {CURRENCY_COUNTRY_MAP, FALL_BACK_CURRENCY} from "../../const/Pay";

export class Sku {
    constructor(paypal, stripe) {
        this.paypal = paypal;
        this.stripe = stripe;
    }
}